module.exports = __webpack_public_path__ + "img/arrow-next.8e0145cd.svg";